import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-view-return-order',
  templateUrl: './view-return-order.component.html',
  styleUrls: ['./view-return-order.component.scss'],
})
export class ViewReturnOrderComponent implements OnInit {
  tabClicked = "selectedProducts";
  orderLines: any;
  viewReturnOrder: any;

  constructor(private alertService: AlertService, private route: ActivatedRoute, private g: Globals, private api: ApiIntegration, public user: User, private router: Router) {
    if (this.user.role === "ROLE_ADMIN") {
      this.g.loaderDisplay = "display";
      this.api.getReturnOrder(this.route.snapshot.params['id']).subscribe((resp: any) => {
        this.viewReturnOrder = resp.data;
        this.orderLines = this.viewReturnOrder.lines;
        this.g.loaderDisplay = "";
      }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    } else {
      this.g.loaderDisplay = "display";
      this.api.getReturnOrder(this.route.snapshot.params['id']).subscribe((data: any) => {
        this.viewReturnOrder = data;
        this.orderLines = this.viewReturnOrder.lines;
        this.g.loaderDisplay = "";
      }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    }

  }


  tabChange(tab) {
    this.tabClicked = tab
  }

  ngOnInit() {
  }

}
